import { css } from "@/wc/registry/lib/framework/lit/index.js";

export const styles = css`
    :host {
        --stekz-default-primary-color: #842cff;
        --stekz-default-primary-box-shadow: #c6b4e0;
        --stekz-primary-light-color: #e5dbf4;
        --stekz-default-white-color: #ffffff;
        --stekz-default-font-size: 1rem;
        --table-font-family-shortened: var(
            --table-font-family,
            var(
                --stekz-font-family,
                var(
                    --font-family,
                    -apple-system,
                    BlinkMacSystemFont,
                    "Segoe UI",
                    Roboto,
                    Helvetica,
                    Arial,
                    sans-serif,
                    "Apple Color Emoji",
                    "Segoe UI Emoji",
                    "Segoe UI Symbol"
                )
            )
        );
        --stekz-default-table-entries-color: #495057;
        --stekz-default-table-paginator-text-color: #6c757d;
        --stekz-default-table-paginator-button-text-color: var(
            --stekz-default-table-entries-color
        );
        --stekz-default-table-paginator-button-hover-color: #e9ecef;
        --stekz-default-table-paginator-button-color: var(
            --primary-light-color,
            var(--stekz-primary-light-color)
        );
        --stekz-default-table-filter-background: #f8f9fa;
        --stekz-default-table-column-text-transform: initial;
        --stekz-default-table-image-width: 250px;
        --stekz-default-table-image-height: 120px;
        --stekz-default-table-image-border-radius: 10px;
        --stekz-default-badge-border-radius: 25px;
        --stekz-default-badge-width: auto;
        --stekz-table-ellipsis-max-width: 100px;
    }

    :host * {
        font-family: var(--table-font-family-shortened);
    }

    thead {
        background-color: var(
            --table-thead-color,
            var(--primary-color, var(--stekz-default-primary-color))
        );
        color: var(
            --default-text-color,
            var(--default-white-color, var(--stekz-default-white-color))
        );
    }

    .table-scroll-wrapper {
        height: var(--table-scroll-wrapper-height, auto);
        overflow-y: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        /* margin: 0;
      border: none; */
    }

    tbody > tr > td {
        font-size: var(
            --table-font-size,
            var(--font-size, var(--stekz-default-font-size))
        );
        color: var(
            --table-entries-color,
            var(--stekz-default-table-entries-color)
        );
        overflow-wrap: anywhere;
    }

    td > svg {
        display: flex;
    }

    tbody > tr {
        height: 1em;
    }

    tbody > tr > td.create-new-entry,
    tbody > tr > td.no-results,
    tbody > tr > td.loading {
        text-align: center;
    }

    thead > tr > th {
        cursor: pointer;
        text-align: start;
        text-transform: var(
            --table-column-text-transform,
            var(--stekz-default-table-column-text-transform)
        );
        font-size: var(
            --table-column-font-size,
            var(--stekz-default-font-size)
        );
    }

    thead > tr > th.not-sortable {
        cursor: default;
    }

    table:not(.compact) td,
    table:not(.compact) th {
        padding: 0.6rem;
    }

    table th span {
        display: flex;
        align-items: center;
    }

    table th span svg {
        margin-left: 0.5rem;
    }

    th.action-buttons {
        width: 0;
    }

    table tbody td {
        border: 1px solid
            var(
                --default-primary-box-shadow,
                var(--stekz-default-primary-box-shadow)
            );
        border-width: 0 0 0.5px 0;
    }

    .action-buttons {
        text-align: right;
    }

    .inline-action-button,
    .inline-edit-button,
    .inline-cancel-button {
        background-color: var(
            --default-white-color,
            var(--stekz-default-white-color)
        );
        border-color: var(
            --stekz-primary-color,
            var(--primary-color, var(--stekz-default-primary-color))
        );
        color: var(
            --stekz-primary-color,
            var(--primary-color, var(--stekz-default-primary-color))
        );
        margin: 0;
        border-radius: 3px;
        border-width: 1px;
        border-style: solid;
        cursor: pointer;
    }

    .inline-delete-confirmation-button {
        background-color: var(
            --default-white-color,
            var(--stekz-default-white-color)
        );
        border-color: rgb(192, 61, 9);
        color: rgb(192, 61, 9);
        margin: 0;
        border-radius: 3px;
        border-width: 1px;
        border-style: solid;
        cursor: pointer;
        background: linear-gradient(
                to left,
                var(--default-white-color, var(--stekz-default-white-color)) 50%,
                rgb(192, 61, 9) 50%
            )
            right;
        background-size: 200%;
        transition: 1.1s ease-out;
    }
    .inline-delete-confirmation-button.is-deleting {
        background-position: left;
        color: white;
    }

    .inline-delete-button {
        background-color: rgb(192, 61, 9);
        border-color: rgb(192, 61, 9);
        color: white;
        margin: 0;
        border-radius: 3px;
        border-width: 1px;
        border-style: solid;
        cursor: pointer;
    }

    .action-buttons button {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .action-buttons.compact button {
        height: 26px;
        width: 26px;
    }

    .action-buttons:not(.compact) button {
        height: 33.2667px;
        width: 33px;
    }

    /* 4*26px (4x compact button) + 3*2px margin */
    .action-buttons.compact button.inline-action-button,
    .action-buttons.compact button.inline-delete-confirmation-button {
        width: 110px;
    }

    /* 4*32px (4x non-compact button) + 3*5px margin */
    .action-buttons:not(.compact) button.inline-action-button,
    .action-buttons:not(.compact) button.inline-delete-confirmation-button {
        width: 143px;
    }

    .action-buttons > span {
        display: flex;
        justify-content: end;
        gap: 4px;
    }

    .action-buttons > span > button > svg {
        align-self: center;
    }

    :not(.compact).inline-cancel-button,
    :not(.compact).inline-delete-button,
    :not(.compact).inline-edit-button {
        margin-left: 5px;
    }
    .compact.inline-cancel-button,
    .compact.inline-delete-button,
    .compact.inline-edit-button {
        margin-left: 2px;
    }

    :not(.compact).inline-cancel-button,
    :not(.compact).inline-edit-button {
        width: 2.357rem;
    }

    .table-filter {
        display: flex;
        justify-content: end;
    }

    .flex-table {
        justify-content: space-between;
        align-items: center;
    }

    .m-0 {
        margin: 0px;
    }
    .fixed-header {
        position: sticky;
        top: 0;
    }
    .table-filter input {
        border: 1px solid;
        border-radius: 5px;
        border-color: var(
            --stekz-primary-color,
            var(--primary-color, var(--stekz-default-primary-color))
        );
    }
    .table-filter input:focus {
        outline: var(
                --stekz-primary-color,
                var(--primary-color, var(--stekz-default-primary-color))
            )
            solid 1px;
    }

    .compact.table-filter {
        padding: 3px;
    }

    .compact.table-filter input {
        font-size: 0.85rem;
    }

    :not(.compact).table-filter input {
        padding: 0.5rem 0.5rem;
    }

    :not(.compact).table-filter {
        padding: 1rem 1rem;
    }

    .paginator {
        padding: 10px;
        display: flex;
        justify-content: end;
        align-items: center;
        color: var(
            --table-paginator-text-color,
            var(--stekz-default-table-paginator-text-color)
        );
    }

    .paginator > span {
        padding: 0 0.5rem;
    }

    .paginator > button {
        border: 0;
        min-width: 2.357rem;
        height: 2.357rem;
        margin: 0.143rem;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(
            --table-paginator-button-text-color,
            var(--stekz-default-table-paginator-button-text-color)
        );
        border-radius: 3px;
        cursor: pointer;
    }

    .compact.paginator * {
        font-size: 0.9rem;
    }

    .compact.paginator > button {
        min-width: 1.5rem;
        height: 1.5rem;
    }

    .paginator > button:hover {
        background: var(
            --table-paginator-button-hover-color,
            var(--stekz-default-table-paginator-button-hover-color)
        );
    }

    .paginator > button.current-page {
        background: var(
            --table-paginator-button-color,
            var(--stekz-default-table-paginator-button-color)
        );
    }

    .badge {
        background-color: #d3d3d3;
        padding: 1px 5px;
        border-radius: var(
            --badge-border-radius,
            var(--stekz-default-badge-border-radius)
        );
        width: var(--badge-width, var(--stekz-default-badge-width));
        color: white;
        font-size: small;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .display-inline {
        display: inline;
    }

    .add-row {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: var(
            --table-font-size,
            var(--font-size, var(--stekz-default-font-size))
        );
        border: 1px solid transparent;
        border-radius: 3px;
        box-shadow: none;
        cursor: pointer;
        background-color: var(
            --stekz-primary-color,
            var(--primary-color, var(--stekz-default-primary-color))
        );
        color: var(
            --default-text-color,
            var(--default-white-color, var(--stekz-default-white-color))
        );
    }

    .add-row-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.3rem;
    }

    .add-row:not(.compact) {
        padding: 6px;
    }

    .add-row-wrapper:not(.compact) {
        padding: 0px;
    }

    .expanded-icon-table-header {
        width: 35px;
    }

    .expanded-row {
        padding: 0px 15px;
    }

    .expand-button {
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        cursor: pointer;
    }

    .cell-image-preview {
        margin: 12px 0px;
        display: flex;
        border-radius: var(
            --table-image-border-radius,
            var(--stekz-default-table-image-border-radius)
        );
        overflow: hidden;
        width: var(--table-image-width, var(--stekz-default-table-image-width));
        height: var(
            --table-image-height,
            var(--stekz-default-table-image-height)
        );
        justify-content: center;
        box-shadow:
            0px 0px 1px rgba(3, 7, 18, 0.02),
            0px 1px 3px rgba(3, 7, 18, 0.04),
            0px 2px 8px rgba(3, 7, 18, 0.06),
            0px 4px 14px rgba(3, 7, 18, 0.08),
            0px 6px 22px rgba(3, 7, 18, 0.1),
            0px 9px 31px rgba(3, 7, 18, 0.12);
    }

    .cell-image-preview img {
        max-width: 100%; /* Set a maximum width to prevent the image from exceeding the container's width */
        max-height: 100%; /* Set a maximum height to prevent the image from exceeding the container's height */
    }

    .ml-10 {
        margin-left: 10px;
    }

    .ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: var(
            --table-ellipsis-max-width,
            var(--stekz-table-ellipsis-max-width)
        );
    }

    .inline-cancel-button:hover {
        filter: brightness(0.8);
    }

    .filter-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
    }
`;

export default styles;
